<template>
  <div>
    <barraprincipaladmin @abrir="mtMenuVisible"/>
    <menulateral @cerrar="mtMenuVisible" :value="menuVisible"> </menulateral>  
    
    <v-container fluid>
        <div class="claro elevation-5">
            <v-row dense>     
                <v-col cols="12" md="9" class="d-flex align-center px-4">
                    <h2 class="primary--text">Solicitudes a Comité Académico</h2>                    
                </v-col>
                <v-col cols="12" md="3" class="d-flex justify-end align-center">
                    <v-btn-toggle color="primary" group v-model="estatus_busqueda" dense>                        
                        <v-btn value="cero"  class="primary--text" @click="getTramites(0)">En proceso </v-btn>
                        <v-btn value="uno" class="primary--text" @click="getTramites(1)">Terminadas </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </div>

        <v-row>
            <v-col cols="12" sm="12" class="d-flex justify-end">
                <v-btn dense color="success" @click="descargarSolictudes()" v-if="tramites_pendientes.length > 0" dark>
                    <v-icon class="mr-2">mdi-cloud-download-outline</v-icon> Descargar
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="tramites_pendientes.length == 0">
            <v-col cols="12" class="d-flex justify-center">
                <v-img src="../../assets/sin_elementos.svg" max-width="150px" max-height="150px"></v-img>
            </v-col>
        </v-row>

        <v-row v-if="tramites_pendientes.length == 0" dense>
            <v-col cols="12" class="d-flex justify-center">
                <span class="headline primary--text">No se encontraron elementos.</span>
            </v-col>
        </v-row>

        <v-expansion-panels hover  v-model="panel_abierto" class="mt-6">

            <v-expansion-panel  v-for="(tramite, key) in tramites_pendientes" v-bind:key="key" @click="detalle_proceso(tramite.calumnoproceso)">

                <v-expansion-panel-header :color="tramite.estatus == 1 ? 'light-blue lighten-5' : 'teal lighten-5' ">
                    <v-row>
                        <v-col cols="12"><h2 class="black--text">{{ tramite.nombre }} {{ tramite.apellido_paterno }} {{ tramite.apellido_materno }}</h2></v-col>
                        <v-col cols="12" class="black--text"><strong>No. Control: </strong>  {{tramite.no_control}} </v-col>                        
                        <v-col class="black--text"><strong>Solicitud: </strong>  {{tramite.fecha_sol}} {{tramite.hora_sol}}  </v-col>
                    </v-row>
                </v-expansion-panel-header>

                <v-expansion-panel-content :id="'contenedor-pasos'+tramite.calumnoproceso">

                    <v-row v-for="(det, index) in detalle_tramite" :key="index" >
                        <v-col>
                            <v-card elevation="3" class="pa-2 mt-3" tile>

                                <v-card-title><strong>Paso {{det.orden}} </strong></v-card-title>
                                <v-card-subtitle><strong>{{det.descripcion}}</strong></v-card-subtitle>
                                <v-divider></v-divider>

                                
                                <!-- Paso 1 documentos -->
                                <div v-if="det.orden == 1" class="mb-2 mt-2"><strong>Documentos</strong></div>

                                <span v-if="det.orden == 1">
                                    <div class="mb-2">
                                        <div class="mb-2"><v-btn @click="descarga(tramite.calumnoproceso, 'solicitud')"><v-icon>mdi-paperclip</v-icon> Solicitud del estudiante</v-btn> </div>                                         
                                    </div>                               
                                </span>

                                
                                <!-- Paso 2 resolucion -->
                                <span v-if="det.orden == 2" class="d-flex">
                                    <!-- <v-text-field class="ancho mr-2" v-model="fecha_reunion" label="Fecha de reunion" outlined dense ></v-text-field>                              -->
                                    <v-menu v-model="modalFec1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fecha_reunion" label="Fecha de reunión" readonly dense outlined v-bind="attrs" v-on="on" ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fecha_reunion" @input="modalFec1 = false"></v-date-picker>
                                    </v-menu>

                                    <v-text-field class="ancho mx-2" v-model="folio_libro" label="Folio de libro" outlined dense></v-text-field>                             
                                    <v-text-field class="ancho mr-2" v-model="folio_hoja" label="Folio de hoja" outlined dense></v-text-field>                                                                 
                                    <v-select label="Estatus" outlined dense class="ancho" :items="estatus_opciones" v-model="estatus"></v-select>                        
                                </span>

                                <!-- Paso 3 documentos -->
                                <div v-if="det.orden == 3" class="mb-2 mt-2"><strong>Documentos</strong></div>

                                <span v-if="det.orden == 3">
                                    <div class="mb-2">                                        
                                        <div class="mb-2"><v-btn @click="descarga(tramite.calumnoproceso, 'recomendaciondirector')"><v-icon>mdi-paperclip</v-icon> Recomendación de Comité Académico</v-btn></div> 
                                        <div class="mb-2"><v-btn @click="descarga(tramite.calumnoproceso, 'dictamen')"><v-icon>mdi-paperclip</v-icon> Dictamen oficial</v-btn></div> 
                                        <div class="mb-5"><v-btn @click="descarga(tramite.calumnoproceso, 'resolucion')"><v-icon>mdi-paperclip</v-icon> Resolución</v-btn></div> 
                                    </div>                               
                                </span>


                                
                                <div class="mt-4">
                                    <v-textarea outlined rows="1" auto-grow label="Comentarios" v-model="det.comentarios" value="" dense></v-textarea>
                                </div>

                                <div v-if="det.orden == 2">
                                    <v-btn dense color="green" @click="actualizaInformacion(tramite.calumnoproceso, det.comentarios)" dark>Guardar</v-btn>
                                </div>

                                <div>
                                    <small><strong>Actualización</strong> {{det.fecha_act}}  {{det.hora_act}} </small>
                                </div>

                                <div class="d-flex justify-end">
                                    <v-btn color="red" dense v-if="tramite.estatus == 0 && det.estatus == 0 " @click="cancelarTramiteDialogo(tramite.calumnoproceso, det.cpaso)"><v-icon>mdi-close-thick</v-icon> Cancelar trámite</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dense v-if="det.estatus==-1" @click="agregarPaso(tramite.calumnoproceso, det.cpaso)"><v-icon>mdi-plus</v-icon> Agregar</v-btn>
                                    <v-btn color="success" dense :disabled="det.estatus == 1" v-if="det.terminal==0 && det.estatus!= -1 && det.estatus!= 2" @click="marcarCompletado(tramite.calumnoproceso, det.cpaso, tramite.cproceso)"><v-icon>mdi-check</v-icon> Completado</v-btn>
                                    <v-btn color="success" dense :disabled="det.estatus == 1" v-if='det.terminal==1 && det.estatus!= -1' @click="marcarFinalizado(tramite.calumnoproceso, det.cpaso)"><v-icon>mdi-check</v-icon> Terminar proceso</v-btn>
                                </div>

                            </v-card>
                        </v-col>
                    </v-row>

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        
        <v-dialog v-model="dialogo" transition="dialog-bottom-transition" max-width="350">
           <v-card>
               <v-toolbar color="yellow lighten-2"><v-icon class="pr-4">mdi-alert-octagon </v-icon><strong> Cancelación de trámite</strong></v-toolbar>
               <v-card-text>                   
                    <div class="pt-8 pb-3 pl-3 pr-3">
                        Realmente quieres cancelar este trámite?
                    </div>                    
               </v-card-text>
               <v-card-actions class="justify-end">
                   <v-btn text @click="cancelarTramite(cancelar_calumnoproceso, cancelar_cpaso)">Si</v-btn>
                   <v-btn text @click="dialogo = false">No</v-btn>
               </v-card-actions>
           </v-card>           
        </v-dialog>

        <v-dialog v-model="dialogo2" transition="dialog-bottom-transition" max-width="350">
           <v-card>
               <v-toolbar color="teal lighten-4"><v-icon class="pr-4">mdi-information </v-icon><strong> Aviso </strong></v-toolbar>
               <v-card-text>                   
                    <div class="pt-8 pb-3 pl-3 pr-3">
                        {{texto_informacion}}
                    </div>                    
               </v-card-text>
               <v-card-actions class="justify-end">
                   <v-btn text @click="dialogo2 = false">Cerrar</v-btn>
               </v-card-actions>
           </v-card>           
        </v-dialog>

        <v-snackbar v-model="snackbar_visible" :color="snackbar_color" light>
            <div class="d-flex justify-center"><b>{{snackbar_texto}}</b></div>
        </v-snackbar>

        <dialogocargando :visible="dialogoCargandoVisible" titulo='Cargando...' descripcion='Espere un momento'></dialogocargando>

    </v-container>
  </div>
</template>

<style scoped>
    .ancho{
        width: 250px;
    }
</style>

<script>
import barraprincipaladmin from '@/components/BarraPrincipalAdmin'
import menulateral from '@/components/MenuLateralAdmin'
import dialogocargando from '@/components/DialogoCargando'

import XLSX from 'xlsx';
export default {
    components:{
        menulateral,
        barraprincipaladmin,
        dialogocargando
    },
    data() {
        return {
            menuVisible: false,
            dialogoCargandoVisible: false,

            snackbar_texto: '',
            snackbar_color: '',
            snackbar_visible: false,            

            estatus_busqueda: "cero",
            dialogo: false,
            cancelar_calumnoproceso: 0,
            cancelar_cpaso: 0,
            
            dialogo2: false,
            texto_informacion: "",


            panel_abierto : -1,
            tramites_pendientes: [],
            detalle_tramite:[],
            
            estatus_opciones:[
                {"text":"Aprobada", "value":"Aprobada"},
                {"text":"Rechazada", "value":"Rechazada"},
                {"text":"Cancelada", "value":"Cancelada"}
            ],

            fecha_reunion: new Date().toISOString().substring(0,10),
            modalFec1: false,
            folio_libro: "",
            folio_hoja: "",
            estatus: "",

            estatus_consulta: 0

        }
    },

    beforeCreate() {      
        const token = sessionStorage.getItem('datax')
               
        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})     
            .then((response)=>{

            const data = response.data
            
            if(data.codigo == 'lgout')
                this.$router.push({"name":'AdminLogin'})
            
            })
            .catch((error)=>{
            console.log("Error "+error);
            })

    },

    created() { 
        this.getTramites(0)  
    },  

    methods: {

        mtMenuVisible(value){
            this.menuVisible = value
        },

        idpaso(cpaso){
            //TODO Revisar si para que se utiliza
            alert(cpaso)
        },

        getTramites(estatus){          
            this.estatus_consulta = estatus 
            this.dialogoCargandoVisible = true;
            this.tramites_pendientes = []

            setTimeout(() => {
                
            

            this.axios.get(this.$url+"/administrativo/seguimiento_tramites/3/"+estatus)
                .then((response)=>{
                    if(response.data.error){
                        alert(response.data.mensaje)
                    }
                    else{
                        this.tramites_pendientes = response.data
                    }                    
                })
                .catch((error)=>{
                    console.log(error);
                })   
                .finally(()=>{                   
                    this.dialogoCargandoVisible = false;                
                })    
                
                }, 2000);
        },

        detalle_proceso(calumnoproceso){

            this.axios.get(this.$url+'/administrativo/seguimiento_tramites/tramite/detalle/'+calumnoproceso)
                    .then( (response)=>{
                        if(response.data.error)
                            console.log("No se pudo consultar el detalle del proceso "+response.data.mensaje)
                        else{

                            this.detalle_tramite = []
                            this.detalle_tramite = response.data

                            let tamaño = response.data.length

                            let up = response.data[tamaño-1]
                            if(up.estatus == 1)
                                this.obtenerSiguientePaso(up.cproceso, up.cpaso, calumnoproceso)
                            
                            
                            //Consultar el detalle de la resolucion
                            this.getResolucion(calumnoproceso)                            
                            
                            this.hacerScroll(calumnoproceso)  
                        }
                    })
                    .catch((error)=>{
                        console.log(error);
                        //alert("Error al consultar detalle "+error)
                    })

        },

        marcarCompletado(calumnoproceso, cpaso, cproceso){

            let comentarios = " "

            for(let paso of this.detalle_tramite){
                if(paso.cpaso == cpaso)
                    comentarios = paso.comentarios
            }


            this.axios.post(this.$url+'/administrativo/seguimiento_tramites/paso/completar', {calumnoproceso, cpaso, comentarios})
                    .then((response)=>{
                        if(response.data.error){
                            console.log("No se pudo actualizar");
                        }
                        else{
                            for(let paso of this.detalle_tramite)
                                if(paso.cpaso == cpaso)
                                    paso.estatus = 1

                            this.obtenerSiguientePaso(cproceso, cpaso, calumnoproceso)
                        }
                    })
                    .catch((error)=>{
                        console.log("Error ACT paso "+error);
                    })

        },

        marcarFinalizado(calumnoproceso, cpaso){

                let comentarios = " "
            
                for(let paso of this.detalle_tramite)
                    if(paso.cpaso ==cpaso)
                        comentarios = paso.comentarios
                    

                this.axios.post(this.$url+'/administrativo/seguimiento_tramites/paso/finalizar', {calumnoproceso, cpaso, comentarios})
                    .then((result)=>{
                        if(result.data.error){
                            console.log(result.data.mensaje);
                        }
                        else{                        
                            console.log(result.data.mensaje);
                            this.detalle_proceso(calumnoproceso)

                            /* Quitar el objeto del arreglo */
                            let index = 0
                            for(let tr of this.tramites_pendientes){                            
                                if(tr.calumnoproceso == calumnoproceso)
                                    this.tramites_pendientes.splice(index, 1)
                                
                                index++
                            }

                        }
                    })
                    .catch((error)=>{
                        console.log("Error "+error);
                    })

        },

        /* Abre el dialogo de confirmacion "Cancelar tramite" */
        cancelarTramiteDialogo(calumnoproceso, cpaso){
            this.cancelar_calumnoproceso = calumnoproceso
            this.cancelar_cpaso = cpaso
            this.dialogo = true          
        },

        /* Cancelar el tramite pasado en parametros */
        cancelarTramite(calumnoproceso, cpaso){            
                this.dialogo = false

                let comentarios = " "
            
                for(let paso of this.detalle_tramite)
                    if(paso.cpaso ==cpaso)
                        comentarios = paso.comentarios
                    

                this.axios.post(this.$url+'/administrativo/seguimiento_tramites/tramite/cancelar', {calumnoproceso, cpaso, comentarios})
                    .then((result)=>{
                        if(result.data.error){
                            console.log(result.data.mensaje);
                        }
                        else{
                            this.texto_informacion = "El trámite ha sido cancelado"
                            this.dialogo2 = true
                            console.log(result.data.mensaje);
                            this.detalle_proceso(calumnoproceso)

                            /* Quitar el objeto del arreglo */
                            let index = 0
                            for(let tr of this.tramites_pendientes){                            
                                if(tr.calumnoproceso == result.data.calumnoproceso)
                                    this.tramites_pendientes.splice(index, 1)
                                
                                index++
                            }
                        }
                    })
                    .catch((error)=>{
                        console.log("Error "+error);
                    })
        },

        obtenerSiguientePaso(cproceso, padre, calumnoproceso){

            console.log("siguiente paso ");


            this.axios.get(this.$url+'/administrativo/seguimiento_tramites/paso/siguiente/obtener/'+cproceso+'/'+padre)
                    .then((response)=>{

                        console.log(response);

                        if(response.data.error){
                            console.log(response.data.mensaje);
                        }
                        else{

                            for(let rs of response.data){
                                this.detalle_tramite.push({
                                                        "comentarios":rs.comentarios,
                                                        "cpaso":rs.cpaso,
                                                        "descripcion":rs.descripcion,
                                                        "estatus":rs.estatus,
                                                        "fecha_act":rs.fecha_act,
                                                        "hora_act":rs.hora_act,
                                                        "orden":rs.orden,
                                                        "padre":rs.padre,
                                                        "terminal":rs.terminal
                                                        })
                            } 
                            
                            this.hacerScroll(calumnoproceso)

                        }
                    })
                    .catch((error)=>{
                        console.log("Error catch en al consultar siguiente paso "+error);
                    })
        },

        hacerScroll(id){
                var container = this.$el.querySelector("#contenedor-pasos"+id);
        
                setTimeout(() => {                

                    this.$vuetify.goTo(container.scrollHeight - 50);
                }, 500);
        },

        agregarPaso(calumnoproceso, cpaso){


            let comentarios = " "

            for(let paso of this.detalle_tramite)
                if(paso.cpaso == cpaso)
                    comentarios = paso.comentarios

            const paso = {
                calumnoproceso: calumnoproceso,
                cpaso: cpaso,
                comentarios: comentarios,
                estatus: 0
            }

            this.axios.post(this.$url+'/administrativo/seguimiento_tramites/paso/siguiente/agregar', {paso})
                .then((response)=>{
                    console.log(response.data);
                    this.detalle_proceso(calumnoproceso);//Recargar el detalle con el nuevo paso agregado
                })
                .catch((error)=>{
                    console.log(error);
                })
        },

        descarga(calumnoproceso, archivo){

                const datos = {
                    calumnoproceso: calumnoproceso
                }

                if(archivo == "solicitud"){           

                    //Funciona bien en Firefox
                    //this.axios.post(this.$url+"/psp/perfil/archivos/descargar", {data}, 
                    this.axios.post(this.$url+"/procesos/comiteacademico/solicitud-formato", datos,
                            {                                
                                responseType: 'blob'
                            })
                
                        .then((response)=>{  

                            if(response.data.error)
                                return

                            const tipo_contenido = response.headers['content-type']
                            const file = new Blob([response.data], {type:tipo_contenido});                            
                            const fileURL = URL.createObjectURL(file)
                            window.open(fileURL)

                        })
                        .catch((error)=>{
                            console.log("Descarga archivo "+error);
                        })
                }                  
                
                if(archivo == "recomendaciondirector")
                    this.axios.post(this.$url+"/procesos/comiteacademico/recomendaciondirector-formato", datos, 
                        {
                            responseType: 'blob'
                        })
                        .then((response)=>{
                            if (response.data.error){  
                                this.snackbar_texto = response.data.mensaje
                                this.snackbar_color = "red"
                                this.snackbar_visible = true 
                                           
                            }  
                            else{
                                const tipo_contenido = response.headers['content-type']
                                const file = new Blob([response.data], {type:tipo_contenido});                            
                                const fileURL = URL.createObjectURL(file)
                                window.open(fileURL)                                 
                            }             
                        })
                        .catch((error)=>{
                            console.log("Descarga archivo "+error);
                        })

                if(archivo == "dictamen")
                    this.axios.post(this.$url+"/procesos/comiteacademico/dictamenoficial-formato", datos,
                        {
                            responseType: 'blob'
                        })                    
                        .then((response)=>{
                            if (response.data.erro){
                                this.snackbar_texto = response.data.mensaje
                                this.snackbar_color = "red"
                                this.snackbar_visible = true                 
                            } 
                            else{
                                const tipo_contenido = response.headers['content-type']
                                const file = new Blob([response.data], {type:tipo_contenido});                            
                                const fileURL = URL.createObjectURL(file)
                                window.open(fileURL)                                    
                            }                
                        })
                        .catch((error)=>{                            
                            console.log("Descarga archivo "+error);
                        })

                if(archivo == "resolucion")
                    this.axios.post(this.$url+"/procesos/comiteacademico/recomendacionalumno-formato", datos,
                        {
                            responseType: 'blob'
                        })
                        .then((response)=>{
                            if (response.data.error){   
                                this.snackbar_texto = response.data.mensaje
                                this.snackbar_color = "red"
                                this.snackbar_visible = true                 
                            }  
                            else{
                                const tipo_contenido = response.headers['content-type']
                                const file = new Blob([response.data], {type:tipo_contenido});                            
                                const fileURL = URL.createObjectURL(file)
                                window.open(fileURL)                         
                            }            
                        })
                        .catch((error)=>{
                            console.log("Descarga archivo "+error);
                        })
        },

        actualizaInformacion(calumnoproceso, comentarios){

            const datos = {
                calumnoproceso: calumnoproceso,
                fecha_reunion: this.fecha_reunion,
                folio_libro: this.folio_libro,
                folio_hoja: this.folio_hoja,
                estatus: this.estatus,
                comentarios: comentarios
            }

            this.axios.post(this.$url+'/procesos/comiteacademico/actualizar', datos)
                    .then((response)=>{
                        const rs = response.data

                        if(!rs.error){
                            this.snackbar_texto = rs.mensaje
                            this.snackbar_color = "green"
                            this.snackbar_visible=true
                        }
                        else{
                            this.snackbar_texto = rs.mensaje
                            this.snackbar_color = "red"
                            this.snackbar_visible=true
                        }                       

                        console.log(response);
                    })
                    .catch((error)=>{
                        console.log("Error ACT paso "+error);
                    })

        },

        getResolucion(calumnoproceso){
            this.axios.get(this.$url+'/procesos/comiteacademico/resolucion/'+calumnoproceso)
                    .then((response)=>{
                        if(!response.data.error){                            
                            const dt = response.data

                            console.log(dt);

                            //this.fecha_reunion = dt.fecha_reunion
                            this.folio_libro = dt.libro
                            this.folio_hoja = dt.foja
                            this.estatus = dt.estatus
                        }
                    })
                    .catch((error)=>{
                        console.log("Error ACT paso "+error);
                    })
        },

        descargarSolictudes(){
            
            this.axios.get(this.$url+'/procesos/comiteacademico/descargarSolicitudes/'+this.estatus_consulta)
                    .then((response)=>{

                        if(!response.data.error){
                            let data = XLSX.utils.json_to_sheet(response.data.solicitudes);
                            const workbook = XLSX.utils.book_new();
                            const filename = "Solicitudes";
                            XLSX.utils.book_append_sheet(workbook, data, filename);
                            
                            XLSX.writeFile(workbook, `${filename}.xlsx`);
                        }

                    })
                    .catch((error)=>{
                        console.log("Error ACT paso "+error);
                    })

        }

    },

};

</script>